import React, { useState, useEffect, useRef } from "react";
import { FaCheckCircle, FaTrash, FaToggleOn, FaToggleOff } from "react-icons/fa";
import "../assets/css/autotrade.css";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import Loader from "../components/Loader";
import ConfirmBuyModal from "../components/ConfirmBuyModal";
import axios from "axios";

import { ITreasureContract, USDTContarct ,DepositContract,NFTContarct} from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import USDTABI from "../abis/USDTABI.json";
import DepositAbi from "../abis/DepositAbi.json";
import NFTABI from "../abis/NFTABI.json";



const AutoTrading = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [USDTBalance, setUSDTBalance] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const [gasFee, setGasFee] = useState(0);
  const [tradeAmount, setTradeAmount] = useState(0);
  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [amount, setAmount] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [availableCapping, setAvailableCapping] = useState("0");
  const [tradeFundAmount, setTradeFundAmount] = useState("0");
const [actionType, setActionType] = useState("deposit");
  const [modalStatus, setModalStatus] = useState({
    visible: false,
    type: "",
    title: "",
    message: "",
    persist: false,
  });

  const timerRef = useRef(null);

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";

  
  // INIT WEB3
  useEffect(() => {
    if (!client) return;
    try {
      const provider = client?.transport || window.ethereum;
      if (provider) setWeb3(new Web3(provider));
    } catch (err) {
      console.log("Web3 Init Error:", err);
    }
  }, [client]);

  useEffect(() => {
    if (!amount || !selectedPlan) {
      setGasFee(0);
      setTradeAmount(0);
      setTermsAccepted(false);
      return;
    }

    const amt = Number(amount);
    let percent = 0;

    if (selectedPlan === 1) percent = 0.2;
    if (selectedPlan === 7) percent = 0.2;
    if (selectedPlan === 30) percent = 1;

    const fee = (amt * percent) / 100;
    const net = amt - fee;

    setGasFee(fee);
    setTradeAmount(net);
  }, [amount, selectedPlan]);

  // TIMER FUNCTION
  const startTimer = (unlockTime) => {
    if (timerRef.current) return;

    timerRef.current = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      let remaining = unlockTime - now;

      if (remaining <= 0) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(remaining / 86400);
      remaining %= 86400;
      const hours = Math.floor(remaining / 3600);
      remaining %= 3600;
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      setTime({ days, hours, minutes, seconds });
    }, 1000);
  };

  // CLEANUP TIMER
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  // FETCH DATA
  const fetchData = async () => {
    if (!web3 || !address) return;

    try {
      setIsLoading(true);

      const USDTInstance = new web3.eth.Contract(USDTABI, USDTContarct);
      const rawUSDT = await USDTInstance.methods.balanceOf(address).call();

      const NFTInstance = new web3.eth.Contract(DepositAbi, DepositContract);
  
      const capData = await NFTInstance.methods
        .getTradingIncomeCapping(address)
        .call();
  
      setAvailableCapping(capData.availableCapping.toString());
      setTradeFundAmount(capData.tradeFundAmount.toString());
      setUSDTBalance(web3.utils.fromWei(rawUSDT.toString(), "ether"));
    } catch (err) {
      console.error("Fetch Error:", err);
      setModalStatus({ visible: true, type: "error", title: "Fetch Error", message: err.message });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (isConnected && web3 && address) fetchData();
  }, [isConnected, web3, address]);


const handleResetCapping = async () => {
  if (!web3 || !address) return;

  try {
    const NFTInstance = new web3.eth.Contract(DepositAbi, DepositContract);

    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Resetting Income Capping...",
    });

    await NFTInstance.methods
      .resetIncomeCapping()
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "Income Capping Reset Successfully!",
    });

    fetchData(); // refresh
  } catch (err) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Error",
      message: err.message,
    });
  }
};

  // HANDLE SETUP
  const handleSetup = async () => {
    if (!amount) {
      setModalStatus({ visible: true, type: "error", title: "Invalid Input", message: "Enter amount.", persist: true });
      return;
    }

    if (!termsAccepted) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Terms Required",
        message: "Please accept Terms & Conditions",
        persist: true,
      });
      return;
    }

    if (!web3 || !address) {
      setModalStatus({ visible: true, type: "error", title: "Wallet Error", message: "Wallet not connected!", persist: true });
      return;
    }

    try {
     // ⭐ STEP 1: USER REGISTERED CHECK
    const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
    const NFTContract = new web3.eth.Contract(DepositAbi, DepositContract);
    const user = await Contract.methods.objUser(address).call();

    if (!user?.userId || user.userId === "0") {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Not Registered",
        message: "Please register first before deposit trading Funds.",
        persist: true,
        setModalStatus,
      });
      return; // ❌ STOP HERE (MetaMask will NOT open)
    }

         /* CAPPING VALIDATION */
     
     const maxCapping = await Contract.methods
     .getCappingLimits(address)
     .call();
     
     const depositInfo = await NFTContract.methods
     .getTradingIncomeCapping(address)
     .call();
     
     const alreadyDeposited = window.BigInt(
     depositInfo.activeDeposit
     );
     
     const maxCap = window.BigInt(maxCapping);
     
     const remaining = maxCap - alreadyDeposited;
     
     const amountWeiCheck = window.BigInt(
     web3.utils.toWei(amount,"ether")
     );
     
     if(amountWeiCheck > remaining){
     
     setModalStatus({
     visible:true,
     type:"error",
     title:"Deposit Limit Exceeded",
     message:`You can deposit only ${web3.utils.fromWei(remaining.toString(),"ether")} USDT more`,
     persist:true
     });
     
     return;
     
     }


      const USDT = new web3.eth.Contract(USDTABI, USDTContarct);

      const amountWei = web3.utils.toWei(amount, "ether");

      setModalStatus({ visible: true, type: "loading", title: "Processing", message: "Approving & Deposit Funds..." });

      await USDT.methods.approve(DepositContract, amountWei).send({ from: address });
      await NFTContract.methods.depositTradingFund(amountWei).send({ from: address });


        setModalStatus({ 
            visible: true, 
            type: "success", 
            title: "Success", 
            message: "Deposit Trading Funds successfully!" 
        });
        
        if(typeof fetchData === "function") fetchData();

    } catch (err) {
        console.error("Detailed Setup Error:", err);
        
        let friendlyMessage = err.message;
        if (err.message.includes("Failed to fetch")) {
            friendlyMessage = "Server Connection Failed. Please check your internet or contact support (CORS issue).";
        }

        setModalStatus({
            visible: true,
            type: "error",
            title: "Setup Failed",
            message: friendlyMessage,
            persist: true,
        });
    }
};


  if (isLoading) return <Loader />;

  return (
    <>
      <h4 className="auto-title">
        <span className="yellow">Deposit</span> <span className="light">Trading Funds</span>
      </h4>

      <div className="card">
        <div className="card-body">
          <div className="auto-body">

            <div className="auto-wallet-card">
              <div className="auto-wallet-label">Wallet Balance</div>
              <div className="auto-wallet-amount">{formatBalance(USDTBalance)} USDT</div>
            </div>


            { (
              <>
                
                {(
                  <div className="auto-input-box">

                  {/* new button add start */}
                  <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                  
                  <button
                  className={`btn ${actionType === "deposit" ? "btn-success" : "btn-outline-success"}`}
                  onClick={() => setActionType("deposit")}
                  >
                  Deposit
                  </button>
                  
                  </div>
                  
                  {/* end */}

                    <label>Enter Amount USDT</label>
                    <div className="inpit-doller">
                      <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Enter USDT amount"
                        className="auto-input"
                      />
                      <span className="iput-icon">   <i className="fa-solid fa-dollar-sign"></i></span>
                    </div>
                  </div>
                )}


                {(
                  <>

                    {/* ===== TERMS (SHOW AFTER AMOUNT) ===== */}
                    <div className="form-check mt-3 terms-row">
                      <input
                        className="form-check-input terms-checkbox"
                        type="checkbox"
                        id="termsCheck"
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                      />
                      <label className="form-check-label terms-label" htmlFor="termsCheck">
                        I agree to the{" "}
                        <span
                          className="terms-link"
                          onClick={() => setShowTermsModal(true)}
                        >
                          Terms & Conditions
                        </span>
                      </label>
                    </div>

                  </>
                )}



                <button className="btn btn-success handleSetupbtn" onClick={handleSetup}>
                 Deposit Trading Funds
                </button>
<button
  disabled={availableCapping !== "0" || tradeFundAmount === "0" }
  className="btn btn-danger mt-3"
  onClick={handleResetCapping}
>
  Reset Income Capping
</button>

              </>
            )}


{/* 
              <div className="auto-card-wrap">
                <div className="auto-amount-card">{formatBalance(botAmount)} USDT<div className="auto-amount-title-tiny">Total Trading Amount</div></div>
                <div className="auto-amount-card">{formatBalance(usedAmountState)} USDT<div className="auto-amount-title-tiny">Used Daily Amount</div></div>
                <div className="auto-amount-card">{formatBalance(availableAmount)} USDT<div className="auto-amount-title-tiny">Daily Limit</div></div>
              </div> */}
          </div>
        </div>
      </div>
      <div class="auto-body">


      </div>

       {/* ===== TERMS MODAL (SAME PAGE) ===== */}
     {showTermsModal && (
  <div className="terms-modal-overlay">
    <div className="terms-modal-box">
      <h5 className="terms-title">Terms & Conditions</h5>

      <div className="terms-content">
        <ol>
          <li>Trading involves market risk.</li>
          <li>Trading duration is based on market volatility.</li>
          <li>User manages funds at own risk.</li>
          <li>No financial advice is provided.</li>
          <li>Smart contract execution is irreversible.</li>
          <li>Gas fees are non-refundable.</li>
          <li>Bot duration is fixed once activated.</li>
          <li>By proceeding, you accept all risks.</li>
        </ol>
      </div>

      <div className="terms-footer">
        <button
          className="btn btn-secondary"
          onClick={() => setShowTermsModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}


      {/* STATUS MODAL */}
      <ConfirmBuyModal
        open={modalStatus.visible}
        status={{ ...modalStatus, setStatusText: setModalStatus }}
        onClose={() => setModalStatus({ ...modalStatus, visible: false })}
      />
    </>
  );
};

export default AutoTrading;